import React, { useState } from 'react';
import { connect } from 'react-redux';
import { updateDashUser } from '../redux/actions/dashusers';
import { updateDashSuppliers, updateVendorUser } from '../redux/actions/suppliers';
import { formValidation } from '../Utils/index';
import CommonModal from './CommonModal';
import CommonTextField from './CommonTextField';

const UpdateUser = ({
  setModal, user, updateManager, updateVendor, userType, updateSupplier,
}) => {
  const [state, setState] = useState({
    full_name: user.full_name,
    mobile: user.mobile,
    username: user.username,
    email: user.email,
  });
  const [validation, formValidate] = useState(null)

  const handleChange = (val, field) => {
    setState((prevState) => ({
      ...prevState,
      [field]: val,
    }));
  };

  const submitForm = async () => {
    let update = 'update';
    if (userType === 'vendor') {
      update = `update-${userType}`;
    }
    const valid = await formValidation(state, update)
    if (valid === undefined) {
      formValidate(null)
      switch (userType) {
        case 'manager':
        case 'buyer':
          updateManager(state, user.id, userType)
          break;
        case 'supplier':
          updateSupplier(state, user.id)
          break;
        default:
          updateVendor(state, user.id)
          break;
      }
      setModal(null)
    } else {
      formValidate(valid)
    }
  }
  const {
    mobile,
  } = state
  return (
    <CommonModal
      title="Update User"
      width="xl"
      open
      onYes={submitForm}
      onClose={() => setModal(false)}
      successButtonText="Update"
      cancelButtonText="Cancel"
      disableEscapeKeyDown
      disableBackdropClick
      saveBtnDisable={
        !state.full_name.trim() && !mobile.trim()
      }
    >
      {
        userType !== 'vendor'
          ? (
            <>
              <div className="row">
                <div className="col-6">
                  <CommonTextField error={validation && validation.full_name} handleChange={handleChange} name="full_name" value={state.full_name} label="Name" placeholder="Full Name" helperText={validation && validation.full_name && validation.full_name.length > 0 ? validation.full_name[0] : ''} required />
                </div>
                <div className="col-6">
                  <CommonTextField error={validation && validation.username} handleChange={handleChange} name="username" value={state.username} label="Username" placeholder="username" helperText={validation && validation.username && validation.username.length > 0 ? validation.username[0] : ''} required />
                </div>
              </div>
              <br />
              <div className="row">
                <div className="col-6">
                  <CommonTextField error={validation && validation.email} handleChange={handleChange} name="email" value={state.email} label="Email" placeholder="Email" type="email" helperText={validation && validation.email && validation.email.length > 0 ? validation.email[0] : ''} required />
                </div>
                <div className="col-6">
                  <CommonTextField error={validation && validation.mobile} handleChange={handleChange} name="mobile" value={state.mobile} label="Mobile No." placeholder="Mobile No." type="tel" helperText={validation && validation.mobile && validation.mobile.length > 0 ? validation.mobile[0] : ''} />
                </div>
              </div>
            </>
          )
          : (
            <>
              <div className="row">
                <div className="col-6">
                  <CommonTextField error={validation && validation.full_name} handleChange={handleChange} name="full_name" value={state.full_name} label="Username" placeholder="Username" helperText={validation && validation.full_name && validation.full_name.length > 0 ? validation.full_name[0] : ''} required />
                </div>
                <div className="col-6">
                  <CommonTextField error={validation && validation.email} handleChange={handleChange} name="email" value={state.email} label="Email" placeholder="Email" type="email" helperText={validation && validation.email && validation.email.length > 0 ? validation.email[0] : ''} />
                </div>
              </div>
              <br />
              <div className="row">
                <div className="col-6">
                  <CommonTextField error={validation && validation.mobile} handleChange={handleChange} name="mobile" value={state.mobile} label="Mobile No." placeholder="Mobile No." type="tel" helperText={validation && validation.mobile && validation.mobile.length > 0 ? validation.mobile[0] : ''} />
                </div>
              </div>
            </>
          )
      }
      <br />
    </CommonModal>
  );
}

const mapActions = {
  updateManager: updateDashUser,
  updateVendor: updateVendorUser,
  updateSupplier: updateDashSuppliers,
};

export default connect(null, mapActions)(UpdateUser);
